import {axiosInstance} from "@/plugins/axios";
import {Customer} from "@/modules/customers/types";

export async function getCustomer(id: string) {
  const response = await axiosInstance.get(`customers/${id}`);
  return response.data;
}

export async function getCustomers() {
  const response = await axiosInstance.get(`customers`);
  return response.data;
}

export async function saveCustomer(customer: Customer) {
  await axiosInstance.post(`customers`, customer);
}

export async function updateCustomer(customer: Customer) {
  await axiosInstance.put(`customers/${customer.id}`, customer);
}

export async function saveCustomers(customers: Customer[]) {
  await axiosInstance.post(`customers/create_or_update_many`, {
    customers: customers
  });
}

export async function saveRawCustomers(customers: Customer[]) {
  return await axiosInstance.post(`customers/raw/create_or_update_many`, {
    customers: customers
  });
}

export async function deleteCustomer(id: string) {
  await axiosInstance.delete(`customers/${id}`)
}
